import { useEffect, useMemo, useState } from 'react';
import { Accordion } from 'react-bootstrap';

import ThreadNode from '../../case-thread/components/ThreadNode';
import {
    buildCaseThreadTree,
    getConversationSubject,
    listThreadMessages,
} from '../../case-thread/helpers/threadTree';
import {
    getMailboxConversationSubject,
    getMessageThread,
} from '../../../helpers';
import '../../case-thread/style.scss';

const MessageConversation = ({
    t,
    message,
}) => {
    const items = useMemo(() => getMessageThread(message), [message]);
    const thread = useMemo(() => buildCaseThreadTree(items), [items]);
    const messages = useMemo(() => listThreadMessages(thread), [thread]);
    const conversationSubject = useMemo(
        () => getConversationSubject(thread) || getMailboxConversationSubject(message),
        [thread, message]
    );
    const newestKey = messages[0]?.key || '';
    const [openIds, setOpenIds] = useState([]);

    useEffect(() => {
        setOpenIds((current) => {
            if (!newestKey) {
                return current.length ? [] : current;
            }

            if (current.length === 1 && current[0] === newestKey) {
                return current;
            }

            return [newestKey];
        });
    }, [newestKey]);

    if (!messages.length) {
        return null;
    }

    return (
        <div className="case-mailbox-thread">
            <div className="case-mailbox-thread__title">
                {conversationSubject || t('(No subject)')}
            </div>
            <Accordion
                alwaysOpen
                activeKey={openIds}
                onSelect={(keys) => setOpenIds(Array.isArray(keys) ? keys : [])}
                className="d-flex flex-column gap-3 mb-4"
            >
                {messages.map((node) => (
                    <ThreadNode
                        key={node.key}
                        node={node}
                        isOpen={openIds.includes(node.key)}
                        t={t}
                    />
                ))}
            </Accordion>
        </div>
    );
};

export default MessageConversation;
